import Text from '../../atoms/Text'

import bannerImg from '../../../assets/images/food_grades.svg'
import cardBottomPattern from '../../../assets/images/info_card_bottom_pattern.png'
import { cardsDatas } from '../../../common/const'
import MobileLayout from '../../MobileLayout'
// import CancelIcon from '../../../assets/icons/cancel_icon.svg'

const FoodScoreInfo = () => {
  return (
    <MobileLayout>
      <section className="lg:max-w-3xl lg:mx-auto lg:pt-10 lg:pb-8">
        <div className="flex justify-center">
          <img src={bannerImg} alt="banner" className="w-full lg:max-w-md" />
        </div>
        <div className="space-y-16 lg:space-y-10 px-4 lg:px-12 mx-auto mt-6">
          <div className="space-y-6">
            {cardsDatas?.map((card, idx) => {
              const { header, descriptions } = card
              return (
                <div
                  key={`${header.title}__${idx}`}
                  className="px-4 pt-4 pb-15 rounded-3 space-y-5 bg-background-secondary overflow-hidden relative"
                >
                  <div className="flex items-center gap-3">
                    <div className="relative h-10 w-10">
                      <img
                        src={header.icon}
                        alt={header.title}
                        height={40}
                        width={40}
                      />
                    </div>
                    <Text
                      tag="p"
                      variant="headline"
                      size="small"
                      className="text-text-primary"
                    >
                      {header.title}
                    </Text>
                  </div>
                  {descriptions?.map((item, index) => (
                    <div
                      key={`${item.title}__${index}`}
                      className="relative z-10"
                    >
                      <div>
                        <Text
                          tag="p"
                          variant="title"
                          size="small"
                          className="text-text-primary"
                        >
                          {item.title}
                        </Text>
                        <Text
                          tag="p"
                          variant="body"
                          size="medium"
                          className="text-text-quartenary mb-[60px] mt-4"
                        >
                          {item.desc}
                        </Text>
                      </div>
                    </div>
                  ))}
                  <img
                    src={cardBottomPattern}
                    alt="bottomPattern"
                    width={147}
                    height={147}
                    className="absolute -right-5 -bottom-11"
                  />
                </div>
              )
            })}
          </div>
        </div>
      </section>
    </MobileLayout>
  )
}
export default FoodScoreInfo
